import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RemoteDiagnosticsVddGenericStructure } from '@vi-iot/client';
import { UnitsStore } from '@store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { SemanticValues } from '../../diagnostics-constants';
import { convertCelsiusToFahrenheit } from '../../../../../../shared/common/units';
import { SUFFIX } from '../../../../../../shared/common/units';

@Component({
  selector: 'app-vdd-sensor',
  templateUrl: './vdd-sensor.component.html',
  styleUrls: ['./vdd-sensor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VddSensorComponent implements OnInit, OnDestroy {
  @Input() matchedValue: RemoteDiagnosticsVddGenericStructure;
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  minValue: RemoteDiagnosticsVddGenericStructure;
  avgValue: RemoteDiagnosticsVddGenericStructure;
  maxValue: RemoteDiagnosticsVddGenericStructure;
  currentValue: RemoteDiagnosticsVddGenericStructure;
  statusValue: RemoteDiagnosticsVddGenericStructure;
  showInfoHover = false;

  constructor(private unitsStore: UnitsStore) {}

  ngOnInit(): void {
    this.unitsStore.isTemperatureMetric$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((isCelsius) => {
        this.matchedValue.structure.forEach((str) => {
          switch (str.semantic) {
            case SemanticValues.SENSORMIN:
              this.minValue = this.setProperValueAndUnit(str, isCelsius);
              break;
            case SemanticValues.SENSORAVG:
              this.avgValue = this.setProperValueAndUnit(str, isCelsius);
              break;
            case SemanticValues.SENSORMAX:
              this.maxValue = this.setProperValueAndUnit(str, isCelsius);
              break;
            case SemanticValues.SENSORVALUE:
              this.currentValue = this.setProperValueAndUnit(str, isCelsius);
              break;
            default:
              if (
                str.semantic.includes(SemanticValues.STATUS) ||
                str.semantic.includes(SemanticValues.ENUM)
              ) {
                this.statusValue = str;
              }
              break;
          }
        });
      });
  }

  getCurrentValueAsPercentOfRange(): number {
    const min = Number(this.minValue.value);
    const max = Number(this.maxValue.value);
    const currentValue = Number(this.currentValue.value);

    if (currentValue >= max) {
      return 100;
    }

    if (currentValue <= min) {
      return 0;
    }

    const range = Math.round((max - min) * 100) / 100;
    const absValue = Math.abs(currentValue);
    const absMin = Math.abs(min);
    const diff = Math.round((absValue - absMin) * 100) / 100;

    return Math.round((diff / range) * 100);
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  private setProperValueAndUnit(
    value: RemoteDiagnosticsVddGenericStructure,
    isCelsius: boolean
  ): RemoteDiagnosticsVddGenericStructure {
    if (!isCelsius) {
      value.value = convertCelsiusToFahrenheit(Number(value.value)).toFixed(1);
      value.unit = SUFFIX.fahrenheit;
    }

    return { ...value };
  }
}
